import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import { omitRetiredOverflowKeys, shellHeaderOverflowPlan } from './shellOverflowPolicy.js';

/** Shell-owned overflow keys — providers may not replace these. */
export const SHELL_OVERFLOW_KEYS = new Set(['newMessage']);

/**
 * Baseline conversation overflow actions owned by the Messages shell.
 * Direct compose is the only shell-owned menu action; providers may append.
 * Navigation back is the existing header button, not a redundant menu entry.
 */
export default function buildShellHeaderOverflowItems(_temp) {
  let {
    onBack
  } = _temp === void 0 ? {} : _temp;
  const items = new ItemList();
  const sources = app.flatrateMessaging ? app.flatrateMessaging.sources() : {
    direct: null
  };
  const plan = shellHeaderOverflowPlan({
    canCompose: !!sources?.direct
  });

  // Callers still pass onBack. The visible Back button owns navigation.
  void onBack;
  if (plan.includes('newMessage')) {
    items.add('newMessage', m(Button, {
      icon: "fas fa-pen",
      onclick: () => {
        if (app.flatrateMessaging && typeof app.flatrateMessaging.composeDirect === 'function') {
          app.flatrateMessaging.composeDirect();
        }
      }
    }, app.translator.trans('flatrate-messaging-ui.forum.page.compose')), 100);
  }
  return items;
}

/**
 * Merge provider contributions under shell items.
 * ItemList.merge overwrites by key — shell is merged last so shell semantics win.
 */
export function mergeHeaderOverflowItems(shellItems, providerItems) {
  const merged = new ItemList();
  const provider = normalizeProviderHeaderOverflowItems(providerItems);
  if (provider) {
    merged.merge(provider);
  }
  if (shellItems) {
    merged.merge(shellItems);
  }
  return omitRetiredOverflowKeys(merged);
}
export function normalizeProviderHeaderOverflowItems(providerItems) {
  if (!providerItems) {
    return null;
  }
  if (typeof providerItems.merge === 'function' && typeof providerItems.toArray === 'function') {
    return providerItems;
  }
  if (Array.isArray(providerItems)) {
    // Legacy array contributions: keep as anonymous low-priority entries.
    const list = new ItemList();
    providerItems.filter(Boolean).forEach((item, index) => {
      list.add(`provider:${index}`, item, 10 - index);
    });
    return list;
  }
  return null;
}
flarum.reg.add('flatrate-messaging-ui', 'forum/utils/buildShellHeaderOverflowItems', buildShellHeaderOverflowItems);